define('views/presence/Podio.Views.Presence.PresenceBar.Followers',['require','lib/backbone/Backbone.PodioView','views/lib/Podio.Views.SlotMachineCount','jst!presence/presence_bar/_followers'],function(require) {

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var SlotMachineCountView = require('views/lib/Podio.Views.SlotMachineCount');

  var jstFollowers = require('jst!presence/presence_bar/_followers');

  return PodioView.extend({

    initialize: function(options) {

      this.count = this.options.count;
      this.elmContainer = this.options.elmContainer;

      this._super();
    },

    updateElementReference: function(elm) {
      this.elmContainer = elm;
    },

    render: function() {
      var html = this.getTemplate(jstFollowers, {
        count: this.count
      });

      this.elmContainer.empty().html(html);

      var elmFollowersSlotCount = this.elmContainer.find('.slot-count');
      if (!this.followersSlotCountView) {
        this.followersSlotCountView = new SlotMachineCountView({
          count: this.count
        });
      }

      this.followersSlotCountView.updateElementReference(elmFollowersSlotCount);
      this.followersSlotCountView.render(this.count);

    }

  });

});

